import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import logo from '@/shared/assets/logo.svg';

import styles from './PreviewFooter.module.scss';

type PreviewFooterProps = {
  text: string;
  blackAndWhiteMode?: boolean;
};

export const PreviewFooter: FC<PreviewFooterProps> = (props) => {
  const { text, blackAndWhiteMode } = props;

  const { formatMessage } = useIntl();

  return (
    <div className={styles.container} data-component="preview-footer">
      <p className={cn(styles.text, 'p4')}>{text}</p>

      <img
        src={logo}
        width={100}
        alt={formatMessage({
          id: 'imgAltText.diagnocat',
          defaultMessage: 'Diagnocat',
        })}
        className={cn(styles.logo, blackAndWhiteMode && styles.blackImg)}
      />
    </div>
  );
};
